var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProofreadNoSegment = function SvgIconProofreadNoSegment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D4D4D4",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.58 21.946 14.367 91.883c-2.394 4.166.614 9.366 5.418 9.366h80.43c4.801 0 7.813-5.2 5.419-9.366L65.42 21.944c-2.402-4.176-8.431-4.18-10.84.002m-6.5-3.743c5.292-9.188 18.553-9.192 23.84.002l40.216 69.94c5.267 9.165-1.352 20.604-11.921 20.604h-80.43c-10.575 0-17.187-11.44-11.921-20.603zM60 41.249A3.75 3.75 0 0 1 63.75 45v20a3.75 3.75 0 1 1-7.5 0V45A3.75 3.75 0 0 1 60 41.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.573 82.22a3.75 3.75 0 0 1 .252 5.297l-.05.055a3.75 3.75 0 0 1-5.55-5.045l.05-.055a3.75 3.75 0 0 1 5.298-.252"
  }))));
};
export default SvgIconProofreadNoSegment;